import type { WarehouseShelvingListFilter } from "@/graphql/codegen/graphql"

export const WAREHOUSE_SHELVING_FILTERS_DEFAULT: Pick<
  WarehouseShelvingListFilter,
  "coldStorage" | "h3ColdStorage" | "deep" | "binSize" | "isAvailable" | "isDoNotUse" | "isUndefined"
> = {
  coldStorage: undefined,
  h3ColdStorage: undefined,
  deep: undefined,

  binSize: [],

  isAvailable: undefined,
  isDoNotUse: undefined,

  isUndefined: undefined,
}

export enum WAREHOUSE_SHELVING_BIN_STATUS {
  AVAILABLE = "AVAILABLE",
  ALLOCATED = "ALLOCATED",
  UNAVAILABLE = "UNAVAILABLE",
  DO_NOT_USE = "DO_NOT_USE",
}

export const WAREHOUSE_SHELVING_BIN_STATUS_LABELS: Record<string, string> = {
  [WAREHOUSE_SHELVING_BIN_STATUS.AVAILABLE]: "Available",
  [WAREHOUSE_SHELVING_BIN_STATUS.ALLOCATED]: "Allocated",
  [WAREHOUSE_SHELVING_BIN_STATUS.UNAVAILABLE]: "Unavailable",
  [WAREHOUSE_SHELVING_BIN_STATUS.DO_NOT_USE]: "Do not use",
}

export const WAREHOUSE_SHELVING_BIN_STATUS_FILTERS: Record<
  string,
  { isAvailable: boolean | undefined; isDoNotUse: boolean }
> = {
  [WAREHOUSE_SHELVING_BIN_STATUS.AVAILABLE]: { isAvailable: true, isDoNotUse: false },
  [WAREHOUSE_SHELVING_BIN_STATUS.UNAVAILABLE]: { isAvailable: false, isDoNotUse: false },
  [WAREHOUSE_SHELVING_BIN_STATUS.DO_NOT_USE]: { isAvailable: undefined, isDoNotUse: true },
}
